import React from 'react';
import ReactDOM from 'react-dom';
import reactFastClick from 'react-fastclick';
import registerServiceWorker from './registerServiceWorker';

import { isIosStandalone } from './util';

import AppContainer from './components/app-container';

import './index.css';

ReactDOM.render(<AppContainer />, document.getElementById('root'));
registerServiceWorker();


// fix clicks on ios
if (isIosStandalone()) {
  reactFastClick();
}



// WEBPACK FOOTER //
// ./src/index.js